const nameFilter = "[A-Za-z0-9 _\\-()/&+.']";
export default nameFilter;
